import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';
import modalQuantityCart from '../modal-quantity-cart/modal-quantity-cart.view.html';
import modalConfirmationCart from '../modal-confirmation/modal-confirmation.view.html';

let inject = [
    '$scope',
    '$state',
    '$rootScope',
    'SharedService',
    'ngAuthSettings',
    'CatalogService',
    'CategoryProductsService',
    '$uibModal',
    '$timeout',
    'CartService',
    'ByFavoritesService',
    '$mdToast',
    'SessionService',
    '$window',
];

class BoxProductsController {
    constructor($scope, $state, $rootScope, SharedService, ngAuthSettings, CatalogService, CategoryProductsService,$uibModal, $timeout, CartService, ByFavoritesService, $mdToast, SessionService,$window) {
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.$window =$window;
        this.$scope = $scope;
        this.CatalogService = CatalogService;
        this.CategoryProductsService = CategoryProductsService;
        this.CartService = CartService;
        this.$timeout = $timeout;
        this.ngAuthSettings = ngAuthSettings;
        this.$rootScope = $rootScope;
        this.SharedService = SharedService;
        this.$mdToast = $mdToast;
        this.productsInfo = {};
        this.btnPrev = "";
        this.btnNext = "";
        this.classCarousel = "";
        this.itemQuantityToAdd = 1;
        this.ByFavoritesService = ByFavoritesService;
        this.SessionService = SessionService;
        this.loadingRelatedProducts=true;
        this.dataCart = {};
        this.dataProducs = {};

        this.productItems = {};

        this.$rootScope.$on('onChangeCompany2', (event, arg) => {

            event.stopPropagation();
            let userId = '';
            try {
                userId = this.shCtrl.globals.currentUser.userId;
            }
            catch (e) {
            }
            let categoryIdFilter = '';
            try{
                if(this.useCategory){
                    categoryIdFilter = arg.id
                }
            }catch(e){
            }

            this.CatalogService.getProducts(userId, 10, this.itemName,'','',categoryIdFilter,this.origin).then(response => {
                this.productsInfo.title = this.itemName;
                this.newProducts = response;
                this.newProducts1 = [];
                this.newProducts2 = [];
                this.Products = [];
                if (response.length) {
                    response.forEach((valFor, indexFor) => {
                        this.Products.push(
                          {
                            "id": valFor.id,
                            "name": valFor.name,
                            "price": valFor.currentPrice,
                          }

                        );
                        if (indexFor <= ((response.length - 1) / 2) || response.length < 8) {
                            this.newProducts1.push(valFor);
                        } else {
                            this.newProducts2.push(valFor);
                        }
                    });
                }

                this.$window.dataLayer.push({
                "ecommerce": {
                  "currencyCode": "COP",
                  "impressions": this.Products
                }
              });
                console.log(this.Products);
                this.initNewProductsCarousel();
                this.loadingRelatedProducts = false;
            }).catch(error => {

            });
        });
    }

    $onInit() {
        this.changeId();
        this.getProducts();
    }

    changeId() {

        let element = angular.element("#contet-carousel");
        try {
            this.classCarousel = element[0].className.split(' ');
            element[0].id = "contet-carousel-" + this.itemName;
            element[0].className = element[0].className + " " + this.itemName;
            angular.element("#des-items-slider-prev")[0].id = this.itemName + "-des-items-slider-prev";
            angular.element("#des-items-slider-next")[0].id = this.itemName + "-des-items-slider-next";
        } catch (e) {
            console.log("error!");
        }
    }

    getProducts() {
      let userId = '';
      try {
        userId = this.shCtrl.globals.currentUser.userId;
      } catch (e) {
      }

      let categoryIdFilter = '';
      try {
        if (this.useCategory) {
          categoryIdFilter = this.category.id
        }


      } catch (e) {

      }
      this.itemName2 = this.itemName.replace('2', '');
      if(this.itemName == 'promociones'){

        let data = {
          limit: 8,
          slugPromition: 'promocion',
        };

        this.CategoryProductsService.getProducts(data).then(response => {

          this.productsInfo.title = this.itemName;
          this.newProducts = response.items;
          this.newProducts1 = [];
          this.newProducts2 = [];
          this.Products = [];
          if (response.length) {
            response.forEach((valFor, indexFor) => {
              this.Products.push(
                {
                  "id": valFor.id,
                  "name": valFor.name,
                  "price": valFor.currentPrice,
                }

              );
              if (indexFor <= ((response.length - 1) / 2) || response.length < 8) {
                this.newProducts1.push(valFor);
              } else {
                this.newProducts2.push(valFor);
              }
            });


            this.$window.dataLayer.push({
              "ecommerce": {
                "currencyCode": "COP",
                "impressions": this.Products
              }
            });
            console.log(this.Products);
          }
          this.initNewProductsCarousel();
          this.loadingRelatedProducts = false;

        }).catch(reason => {
          console.log("response");

        });

      }else{
      this.CatalogService.getProducts(userId, 10, this.itemName2, '', '', categoryIdFilter, this.origin).then(response => {
        this.productsInfo.title = this.itemName2;
        this.newProducts = response;
        this.newProducts1 = [];
        this.newProducts2 = [];
        if (response.length) {
          response.forEach((valFor, indexFor) => {
            if (indexFor <= ((response.length - 1) / 2) || response.length < 8) {
              this.newProducts1.push(valFor);
            } else {
              this.newProducts2.push(valFor);
            }
          });
        }
        // console.log(this.newProducts1);
        this.initNewProductsCarousel();
        // initBrandsCarousel();

        this.loadingRelatedProducts = false;
      }).catch(error => {

      });
    }
    }

    initNewProductsCarousel() {

        this.$timeout(() => {
            let newItems = $('.' + this.classCarousel[0] + '.' + this.classCarousel[1] + '.' + this.itemName);
            newItems.owlCarousel({
                items: 4,
                itemsDesktop: [1199, 3],
                itemsDesktopSmall: [979, 2],
                itemsTablet: [768, 2],
                itemsMobile: [479, 1],
                slideSpeed: 400,
                autoPlay: 8000,
                stopOnHover: true,
                navigation: false,
                pagination: false,
                responsive: true,
                mouseDrag: false
            }).data('navigationBtns', ['#' + this.itemName + '-des-items-slider-prev', '#' + this.itemName + '-des-items-slider-next']);
            newItems.each(function () {
                let $this = $(this),
                    owlCarousel = $this.data('owlCarousel'),
                    owlBtns = $this.data('navigationBtns'),
                    prevBtn, nextBtn;

                if (typeof owlCarousel === 'undefined' || typeof owlBtns === 'undefined') {
                    return;
                }

                for (let key in owlBtns) {
                    if (owlBtns[key].indexOf('next') === -1) {
                        prevBtn = $(owlBtns[key]);
                    } else {
                        nextBtn = $(owlBtns[key]);
                    }
                }

                prevBtn.on('click touchstart', function (e) {
                    owlCarousel.prev();
                    e.preventDefault();
                });

                nextBtn.on('click touchstart', function (e) {
                    owlCarousel.next();
                    e.preventDefault();
                });
            });

            $('.add-tooltip').tooltip();
        }, 1000);
    }

    setItemToAddToCart(product) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalQuantityCart,
            controller: 'ModalQuantityCartController',
            controllerAs: 'mdCtrl',
            size: 'sm',
            resolve: {
                product: () => product
            }
        });
        modalInstance.result.then(result => {
            if (result.product.id && result.quantity) {
                let userId = '', cart = null;
                let currentUser = this.SessionService.get('currentUser');

                try {
                    userId = currentUser.userId ? currentUser.userId : this.shCtrl.globals.currentUser.userId;
                } catch (e) {
                }
                try {
                    cart = this.shCtrl.cart;
                } catch (e) {
                }

                let validation  = this.SessionService.validateFactorItems(result.quantity,product);

                if(validation.error){

                    let options = {
                        title: '',
                        isHtml: true,
                        content: validation.message,
                        size: '',
                        showBottonCancel: false,
                        textActionCancel: '',
                        textAction: 'Aceptar'
                    };
                    this.messageResponse(options);
                    return;
                }


                this.CartService.addItemToCart(result.product, result.quantity, null, null, userId, cart).then(response => {
                    if (!response.error) {
                        this.dataCart = {};
                        this.dataProducs = {};
                        this.modalConfirmation(product,result.quantity);
                    } else {

                        if (response.agotado) {
                            product.cantidad = response.itemStock;
                            this.CartService.updateItemsNotAvailable(product, result.quantity, userId);
                        }

                        let options = {
                            title: '',
                            isHtml: true,
                            content: response.message,
                            size: '',
                            showBottonCancel: false,
                            textActionCancel: '',
                            textAction: 'Aceptar'
                        };
                        this.messageResponse(options);
                    }
                }).catch(reason => {
                    let options = {
                        title: '',
                        isHtml: false,
                        content: reason,
                        size: '',
                        showBottonCancel: false,
                        textActionCancel: '',
                        textAction: 'Aceptar'
                    };
                    this.messageResponse(options);
                });
            }
        }).catch(error => {

        });
    }

    updateFavoriteProducts(product) {
        product.isSettingAsFavorite = true;
        let userId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        }
        catch (e) {
        }
        if (userId) {
            let data = {
                'productId': product.id,
                'userId': userId,
                'setFavorite': !product.isFavorite
            };
            this.CatalogService.updateFavoriteProducts(data).then(response => {

                if (!response.error) {
                    this.ByFavoritesService.getResumeProductsFavorites(this.shCtrl.globals.currentUser.userId).then(favoritesResponse => {
                        this.shCtrl.globals.currentUser.favoriteItems = favoritesResponse;
                        this.SessionService.put('globals', this.shCtrl.globals);
                    });
                }
                product.isFavorite = !product.isFavorite;
                product.isSettingAsFavorite = false;
            }).catch(error => {
                product.isSettingAsFavorite = false;
                let options = {
                    title: '',
                    isHtml: false,
                    content: 'Ha ocurrido un error al actualizar el producto',
                    size: '',
                    showBottonCancel: false,
                    textActionCancel: '',
                    textAction: 'Aceptar'
                };
                this.messageResponse(options);
            });
        }
    }

    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }

    messageMaterial(text) {
        var mdToast = this.$mdToast;
        this.$mdToast.show({
            hideDelay: 4000,
            controller: function () {
                this.closeToast = function () {
                    mdToast.hide();
                }

            },
            controllerAs: 'toast',
            template: '<md-toast>\n' +
            '  <span class="md-toast-text">' + text + '</span>\n' +
            '  <md-button ng-click="toast.closeToast()">\n' +
            '    Cerrar\n' +
            '  </md-button>\n' +
            '</md-toast>'
        });
    }


    modalConfirmation(products, quantity) {

        this.productAdded = products;
        this.productAdded.activateVolumenPrice = products.activateVolumenPrice;
        this.productAdded.image = products.imagesDetail[0].path + products.imagesDetail[0].image;
        this.productAdded.price = products.itemPrice;
        this.productAdded.discount = products.discountValue;
        this.productAdded.ivaValue = products.taxValue;
        this.productAdded.quantity = quantity;

        if (products.preciosxvolumen == null) {
          this.productAdded.total = (products.itemPrice - products.discountValue + products.taxValue) * quantity;
        }

        else if (!products.preciosxvolumen[2] && !products.preciosxvolumen[1]) {
          if (products.quantity > products.preciosxvolumen[0].hasta){
            this.productAdded.total = (products.preciosxvolumen[0].itemPrice - products.preciosxvolumen[0].itemDiscount + products.preciosxvolumen[0].taxValue) * quantity;
          }
          else {
            this.productAdded.totalpxv1 = (products.preciosxvolumen[0].itemPrice - products.preciosxvolumen[0].itemDiscount + products.preciosxvolumen[0].taxValue) * quantity;
          }
        }

        else if (!products.preciosxvolumen[2]){
          if (products.quantity > products.preciosxvolumen[1].hasta){
            this.productAdded.total = (products.preciosxvolumen[1].itemPrice - products.preciosxvolumen[1].itemDiscount + products.preciosxvolumen[1].taxValue) * quantity;
          }
          else {
            this.productAdded.totalpxv1 = (products.preciosxvolumen[0].itemPrice - products.preciosxvolumen[0].itemDiscount + products.preciosxvolumen[0].taxValue) * quantity;
            this.productAdded.totalpxv2 = (products.preciosxvolumen[1].itemPrice - products.preciosxvolumen[1].itemDiscount + products.preciosxvolumen[1].taxValue) * quantity;
          }
        }

        else {
          this.productAdded.totalpxv1 = (products.preciosxvolumen[0].itemPrice - products.preciosxvolumen[0].itemDiscount + products.preciosxvolumen[0].taxValue) * quantity;
          this.productAdded.totalpxv2 = (products.preciosxvolumen[1].itemPrice - products.preciosxvolumen[1].itemDiscount + products.preciosxvolumen[1].taxValue) * quantity;
          this.productAdded.totalpxv3 = (products.preciosxvolumen[2].itemPrice - products.preciosxvolumen[2].itemDiscount + products.preciosxvolumen[2].taxValue) * quantity;
        }

        if (__env.adaptative) {
            this.messageMaterial(products.name + ' Ha sido agregado correctamente')
        } else {
            let modal = this.itemName;
            $('#' + modal).modal('toggle');
        }

        this.$scope.$emit('onUpdateCart', 'modalResponseItems');
    }

    increaseItemQuantityToAdd() {
        if (!this.itemQuantityToAdd)
            this.itemQuantityToAdd = 1;
        else
            this.itemQuantityToAdd++;
    };

    decreaseItemQuantityToAdd() {
        if (!this.itemQuantityToAdd)
            this.itemQuantityToAdd = 1;
        else if (this.itemQuantityToAdd > 1) {
            this.itemQuantityToAdd--;
        }
    };
}

BoxProductsController.$inject = inject;

export default BoxProductsController;




/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/box-products/box-products.controller.js
 **/